module.exports = __webpack_public_path__ + "static/media/var1.7966649c.svg";